// extracted by mini-css-extract-plugin
export default {"container":"PrimaryButton-module--container--zRGUV","rebrandContainer":"PrimaryButton-module--rebrandContainer--9QRX7"};